module.exports = __webpack_public_path__ + "static/media/delete-icon.668b9233.svg";